import { createSelector } from "reselect";

const selectAuth = (state) => state.auth;

export const selectAuthUser = createSelector(
    [selectAuth],
    auth => auth.currentUser
);

export const selectAuthSessionStatus = createSelector(
    [selectAuth],
    auth => auth.sessionStatus
);

export const selectAuthLoading = createSelector(
	[selectAuth],
	auth => auth.loading
);

export const selectAuthErrors = createSelector(
    [selectAuth],
    auth => auth.error
);

export const selectAuthStatusForgotPassword = createSelector(
    [selectAuth],
    auth => auth.statusForgotPassword
);

export const selectAuthStatusResetPassword = createSelector(
    [selectAuth],
    auth => auth.statusResetPassword
);

export const selectLastActiveWorkspaceId = createSelector(
    [selectAuth],
    auth => auth.lastActiveWorkspaceId
);
